module.exports = __webpack_public_path__ + "static/media/bg_page3.63ae2f36.png";